/* eslint-disable no-unused-vars */
import { useDispatch, useSelector } from "react-redux";

import { IRootState } from "../../../state";
import { IWellnessPlanDetails } from "../../../services/wellness-plan/wellness-plan.interface";
import React from "react";
import wellnessPlanActions from "../../../state/wellness-plan-details/wellness-plan.actions";

const useWellnessPlanRecord = () => {
  const wellnessPlanRecord = useSelector((state: IRootState) => state.wellnessPlan);
  const dispatch = useDispatch();

  const setWellnessPlanRecord = (payload: IWellnessPlanDetails | null) => {
    dispatch(wellnessPlanActions.setWellnessPlanDetails(payload));
  };

  return {
    wellnessPlanRecord,
    setWellnessPlanRecord,
  };
};

export default useWellnessPlanRecord;
